import { render, staticRenderFns } from "./Responses.vue?vue&type=template&id=7c47881c"
import script from "./Responses.vue?vue&type=script&lang=js"
export * from "./Responses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports